import type {ComponentProps} from 'react'
import {Button} from '@primer/react'
import {useButton} from '../contexts/ButtonContext'

export function AnchorButton({children, ...props}: Omit<ComponentProps<typeof Button>, 'ref' | 'onClick'>) {
  const {onClick, buttonRef} = useButton()
  return (
    <Button {...props} onClick={onClick} ref={buttonRef}>
      {children}
    </Button>
  )
}

AnchorButton.displayName = 'ImportBranchProtectionDialog.AnchorButton'
